import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { usePageMeta } from "../hooks/usePageMeta";
import { Hero } from "../components/home/Hero";
import { Marquee } from "../components/Marquee";
import { ChiSiamo } from "../components/home/ChiSiamo";
import { ServiziGrid } from "../components/home/ServiziGrid";
import { Perche } from "../components/home/Perche";
import { Metodo } from "../components/home/Metodo";
import { SplitAudience } from "../components/home/SplitAudience";
import { ContattiSection } from "../components/home/ContattiSection";
import { CTABand } from "../components/CTABand";
import { SectionHeading } from "../components/SectionHeading";
import { Reveal } from "../components/Reveal";
import { Gallery, DemoNote } from "../components/Gallery";

export default function Home() {
  usePageMeta(
    "Costruzioni Ciosko | Impresa Edile in Veneto",
    "Costruzioni Ciosko è un'impresa edile operativa in Veneto. Realizziamo opere murarie, ristrutturazioni, cartongesso, finiture e interventi edili per privati e aziende."
  );
  return (
    <>
      <Hero />
      <Marquee />
      <ChiSiamo />
      <ServiziGrid />
      <Perche />
      <section data-testid="lavori-preview-section" className="py-20 lg:py-32 bg-graphite border-y border-steel">
        <div className="max-w-7xl mx-auto px-5 lg:px-10">
          <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-8 mb-10">
            <SectionHeading
              number="04"
              overline="Portfolio"
              lines={["I nostri lavori"]}
              description="Ogni cantiere racconta il nostro modo di lavorare."
            />
            <Reveal delay={0.2}>
              <Link to="/lavori" data-testid="lavori-all-button" className="btn-ghost shrink-0">
                Tutti i lavori <ArrowUpRight size={16} />
              </Link>
            </Reveal>
          </div>
          <div className="mb-8"><DemoNote /></div>
          <Gallery limit={6} />
        </div>
      </section>
      <Metodo />
      <SplitAudience />
      <CTABand />
      <ContattiSection />
    </>
  );
}
